module.exports = __webpack_public_path__ + "media/images/menu/ariel-e3cbfc38ccdfb9c4dd51775ede9a85ec.jpg";